import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import { InfoOutlined, TimerOutlined } from '@mui/icons-material';

/**
 * OTRIX Play — nota del descanso según el ACSM. El mismo bloque se usa en el descanso en vivo del
 * runner y en el cierre del entrenamiento, así el mensaje no se cuenta de dos formas distintas.
 * Monocromo: el dorado entra solo como ícono cuando hay algo que ajustar.
 */
function RestAdviceNote({ advice, sx = undefined }) {
  const needsWork = advice.level === 'short' || advice.level === undefined;

  return (
    <Box
      sx={{
        width: '100%',
        p: 1.5,
        borderRadius: '12px',
        border: '1px solid',
        borderColor: 'hairline.main',
        backgroundColor: 'surface.overlay',
        textAlign: 'left',
        ...sx
      }}>
      <Stack direction="row" spacing={1.25} alignItems="flex-start">
        <Box sx={{ display: 'flex', flex: 'none', mt: '2px', color: needsWork ? 'gold.main' : 'text.secondary' }}>
          {needsWork ? <TimerOutlined sx={{ fontSize: 18 }} /> : <InfoOutlined sx={{ fontSize: 18 }} />}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" fontWeight={800} display="block">
            {advice.title}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {advice.body}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}

RestAdviceNote.propTypes = {
  /** Salida de `restAdviceFor` o `restSkipSummary` (components/play/restAdvice). */
  advice: PropTypes.shape({
    level: PropTypes.string,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
  }).isRequired,
  sx: PropTypes.object
};

export default RestAdviceNote;
